import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { dataEachInfo } from './TermsInformations'
import { selectedOrgsState } from '../states'
import { useRecoilValue } from 'recoil'

const DataEachTerms1 = () => {

	const App = useApp()
	const mounted = useRef()
	const navigate = useNavigate()
	const [buttonText, setButtonText] = useState("아래로 내려보기")
	const [atBottom, setAtBottom] = useState(false)
	const [industries, setIndustries] = useState([])
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	const core = useRef()

	const onNext = () => {
		if (atBottom) {
			navigate("/data/dataEachTerms2")
		} else {
			const scrollTop = core.current.scrollTop
			const pageHeight = document.body.scrollHeight
			core.current.scrollTo(0, (scrollTop + pageHeight) * 0.8)
		}
	}

	const bindScroll = () => {
		core.current = document.querySelector(".core")
		setTimeout(() => {
			if (core.current.clientHeight >= core.current.scrollHeight - 30) {
				!mounted.current && setAtBottom(true)
			}
		}, 300)
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	useEffect(() => {
		if (atBottom) {
			setButtonText("동의하기")
		} else {
			setButtonText("아래로 내려보기")
		}
	}, [atBottom])

	useEffect(() => {
		if (selectedOrgs) {
			const newList = []
			selectedOrgs.forEach(org => {
				if (!newList.some(industry => industry === org.indstCd)) newList.push(org.indstCd)
			})
			setIndustries(newList)
		}
	}, [selectedOrgs])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted.current && bindScroll()

		return () => mounted.current = false
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["count-group"]}>
					<p>전송요구 및 정보 제공 동의</p>
					<div><span>3</span>/3</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40 pb_100`}>
					<p>개인(신용) 정보 수집 ・ 이용 동의서(상세정보전송)</p>
					<span className="mt_10">
						핀테크는 ⌜신용정보의 이용 및 보호에 관한 법률⌟, ⌜개인정보 보호법⌟등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
					</span>
					<ul className="mt_40">
						<li>
							<div>거부 권리 및 불이익</div>
							<span>
								귀하는 개인(신용)정보 수집 ・ 이용에 관한 동의를 거부 하실 수 있습니다. 다만, “필수 항목에 대한 수집 ・ 이용에 관한 동의”는 본인신용 정보 통합 조회, 데이터분석 서비스의 이용을 위한 필수적 사항이므로 동의를 거부하실 경우 본인신용정보 통합조회, 데이터분석 서비스의 이용이 제한될 수 있으며, “선택 항목에 대한 수집 ・ 이용에 관한 동의”는 거부하실 경우 해당 선택 항목에 대한 본인신용정보통합조회, 데이터분석 서비스의 이용이 제한될 수 있습니다.
							</span>
						</li>
						<li>
							<div>수집 ・ 이용 목적</div>
							<span>
								전송요구를 통한 본인신용정보 통합조회, 데이터분석 서비스의 이용
							</span>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<p className="mt_10 text-blue">서비스 이용 종료 시 또는 삭제 요구 시까지</p>
						</li>
						<li>
							<div>수집 ・ 이용 항목</div>
							<div className={styles.category}>
								<div>
									<p>개인(식별)정보</p>
									<span>・ 접근토큰</span>
								</div>
							</div>
							<div className={styles.category}>
								<div>
									<p>개인(신용)거래정보</p>
									<div className="pl_10">
										{
											industries &&
											industries.map((item, index) => {
												return (
													<div key={index} className={index > 0 ? "mt_5" : undefined}>
														<div className='bold'>{dataEachInfo[item].name}</div>
														<span style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}>{dataEachInfo[item].data}</span>
													</div>
												)
											})
										}
									</div>
								</div>
							</div>
							<div className={styles.category}>
								<div>
									{
										(industries.indexOf("bank") > -1 || industries.indexOf("card") > -1 || industries.indexOf("efin") > -1 || industries.indexOf("pcard") > -1 || industries.indexOf("invest") > -1) &&
										<>
											<p>선택항목</p>
											<div style={{ color: "#333" }}>* 정보주체가 전송 요구 시 해당 정보를 선택하는 경우에 한함</div>
										</>
									}
									<div>
										<span>
											{(industries.indexOf("bank") > -1 || industries.indexOf("efin") > -1 || industries.indexOf("invest") > -1) && <span>・ 적요 또는 거래메모 정보</span>}
											{(industries.indexOf("card") > -1 || industries.indexOf("efin") > -1 || industries.indexOf("pcard") > -1) && <span>・ 가맹점명 및 사업자등록번호 정보</span>}
											{industries.indexOf("efin") > -1 && <span>・ 상품구매정보</span>}
										</span>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<p className="mt_30">위와 같은 개인(신용)정보 수집 ・ 이용에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big" onClick={onNext}>{buttonText}</Button>
			</div>
		</div>
	)
}

export default DataEachTerms1